import AlertModal from "modals/AlertModal";
import MsgModal from "modals/MsgModal";
import Post from "modals/Post";
import TermsModal from "modals/TermsModal";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { requestGet, requestPost } from "utils/AxiosApi";

import "style/style.css";
import {
  phoneHyphen,
  emailValidate,
  passwordValidate,
} from "utils/CommonUtils";

import Loader from "utils/Loader";
const medmall_header = "/img/medmall_header.png";

const Join = () => {
  let history = useNavigate();

  //주소 모달창 open
  const [addModalOpen, setAddModalOpen] = useState(false);
  //약관 모달창 open
  const [termsModalOpen, setTermsModalOpen] = useState(false);

  //모달 alert
  const [AlertModalOpen, setAlertModalOpen] = useState(false);
  const [AlertModalMsg, setAlertModalMsg] = useState("");

  //모달창 open
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [modalKind, setModalKind] = useState("I");

  //loader
  const [isLoading, setIsLoading] = useState(false);

  const [terms, setTerms] = useState({ seq: 0 });
  const [termsA, setTermsA] = useState({ seq: 0 });
  const [termsB, setTermsB] = useState({ seq: 0 });
  const [termsC, setTermsC] = useState({ seq: 0 });

  const [regInputs, setRegInputs] = useState({
    email: "",
    password: "",
    name: "",
    gender: "M",
    phone: "",
    orgNm: "",
    orgNum: "",
    addr: "",
    addDetail: "",
    agreeTermsA: false,
    agreeTermsB: false,
    agreeTermsC: false,
    termsAseq: 0,
    termsBseq: 0,
    termsCseq: 0,
  });

  const [emptyinputs, setEmptyinputs] = useState("");

  const [pwchk, setPwchk] = useState("");

  const setRegInputsData = (name: any, value: any) => {
    setRegInputs({
      ...regInputs,
      [name]: value,
    });
  };

  const inputChange = (e: any) => {
    const { value, name } = e.target;
    setRegInputsData(name, value);
  };

  const radioLabelBtnClick = (value: any) => {
    setRegInputsData("gender", value);
  };

  const phoneValidate = (e: any) => {
    const { value, name } = e.target;
    let phoenNumber = phoneHyphen(value);
    setRegInputsData(name, phoenNumber);
  };

  const inputPwchk = (e: any) => {
    setPassworeChkValid(true);
    setPwchk(e.target.value);
  };

  const {
    email,
    password,
    name,
    gender,
    phone,
    orgNm,
    orgNum,
    addr,
    addDetail,
    agreeTermsA,
    agreeTermsB,
    agreeTermsC,
  } = regInputs;

  const termsModalCallback = (check: boolean, kind: string) => {
    setTermsModalOpen(false);
    if (check) {
      agreeTermsCheck(kind, true);
    }
  };

  const agreeTermsCheck = (kind: String, value = false) => {
    var name = "";
    var seqKey = "";
    var seqValue = 0;
    if (kind === "A") {
      name = "agreeTermsA";
      if (!agreeTermsA) {
        seqKey = "termsAseq";
        seqValue = termsA.seq;
        value = true;
      }
    } else if (kind === "B") {
      name = "agreeTermsB";
      if (!agreeTermsB) {
        seqKey = "termsBseq";
        seqValue = termsB.seq;
        value = true;
      }
    } else if (kind === "C") {
      name = "agreeTermsC";
      if (!agreeTermsC) {
        seqKey = "termsCseq";
        seqValue = termsC.seq;
        value = true;
      }
    }

    setRegInputs({
      ...regInputs,
      [seqKey]: seqValue,
      [name]: value,
    });
  };

  const moveScreen = () => {
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  };

  const btnShowTerms = (type: String) => {
    if (type === "A") {
      setTerms(termsA);
    } else if (type === "B") {
      setTerms(termsB);
    } else if (type === "C") {
      setTerms(termsC);
    }
    setTermsModalOpen(true);
  };

  const isEmpty = (value: any) => {
    if (value.length > 0) {
      return false;
    }
    return true;
  };

  const [idValidMsg, setIdValidMsg] = useState("");
  const [passwordValid, setPassworeValid] = useState(true);
  const [passwordChkValid, setPassworeChkValid] = useState(true);

  const checkEmptyInput = () => {
    var submitInput = false;

    var emailVali = emailValidate(regInputs.email);

    if (!emailVali.valid) {
      setIdValidMsg(emailVali.id);
      setEmptyinputs("email");
      moveScreen();
      setModalOpen(true);
      setModalMsg(emailVali.id);
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.password)) {
      setEmptyinputs("pw");
      moveScreen();
      setModalOpen(true);
      setModalMsg("비밀번호를 입력해주세요");
      return submitInput;
    } else if (
      !passwordValidate(regInputs.password, setModalOpen, setModalMsg)
    ) {
      // alert("비밀번호는 문자 및 숫자를 조합한 6자리 이상으로 구성해주세요.");
      moveScreen();
      setPassworeValid(false);
      return submitInput;
    } else {
      setEmptyinputs("");
      setPassworeValid(true);
    }

    if (isEmpty(pwchk)) {
      setModalOpen(true);
      setModalMsg("비밀번호 확인을 해주세요");
      setPassworeChkValid(false);
      moveScreen();
      return submitInput;
    } else {
      setPassworeChkValid(true);
    }

    if (isEmpty(regInputs.name)) {
      setModalOpen(true);
      setModalMsg("이름을 입력해주세요.");
      setEmptyinputs("name");
      moveScreen();
      return submitInput;
    } else if (password !== pwchk) {
      setModalOpen(true);
      setModalMsg("비밀번호가 일치하지 않습니다.");
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.phone)) {
      setModalOpen(true);
      setModalMsg("연락처를 입력해주세요.");
      setEmptyinputs("phone");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.orgNm)) {
      setModalOpen(true);
      setModalMsg("의료기관명을 입력해주세요.");
      setEmptyinputs("orgNm");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.orgNum)) {
      setModalOpen(true);
      setModalMsg("요양기관번호를 입력해주세요.");
      setEmptyinputs("orgNum");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.addr)) {
      setModalOpen(true);
      setModalMsg("주소를 입력해주세요.");
      setEmptyinputs("addr");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    return true;
  };

  const memberSignUp = async () => {
    setSubmitBtn(false);
    setIsLoading(true);

    let data = await requestPost("/api/join", {
      regInputs,
    });

    if (data.result === true) {
      setModalMsg(
        "회원가입 신청이 완료되었습니다.\n\n" +
          "현재 ‘승인대기’ 상태로 관리자가 확인 후 \n" +
          "가입승인이 진행됩니다.\n\n" +
          "가입승인이 완료되면,\n" +
          "등록해주신 휴대폰번호로\n" +
          "안내문자를 발송드리고 있습니다.\n"
      );
      setIsLoading(false);
      setModalKind("S");
      setModalOpen(true);
    } else if (data.result === false) {
      setModalOpen(true);
      setModalMsg(data.duplicate);
      setIdValidMsg(data.duplicate);
      setEmptyinputs("email");
      moveScreen();
      setSubmitBtn(false);
      setIsLoading(false);
    }
  };

  const [submitBtn, setSubmitBtn] = useState(false);

  const onSubmit = () => {
    var submit = checkEmptyInput();
    if (submit) {
      if (!agreeTermsA || !agreeTermsB || !agreeTermsC) {
        setModalOpen(true);
        setModalMsg("약관에 모두 동의해주세요.");
        return;
      } else if (!submitBtn) {
        setAlertModalOpen(true);
        setAlertModalMsg("회원가입을 진행하시겠습니까?");
      }
    }
  };

  const alertConfirm = () => {
    memberSignUp();
  };

  const getInitData = async () => {
    var data: any = await requestGet("/api/clause/get/list", {});
    data.map((d: any) => {
      if (d.kind === "A") {
        setTermsA(d);
      } else if (d.kind === "B") {
        setTermsB(d);
      } else if (d.kind === "C") {
        setTermsC(d);
      }
      return d;
    });
  };

  useEffect(() => {
    getInitData();
  }, []);

  const modalConfirm = () => {
    if (modalKind === "S") {
      history("/");
    } else {
      moveScreen();
    }
    setModalOpen(false);
  };

  return (
    <div>
      <div className="display-center-margin-50">
        <div
          className="title_logo_img"
          style={{ textAlign: "center", marginBottom: "35px" }}
        >
          <img src={medmall_header} alt="medmall_header_logo"></img>
        </div>
        <div style={{ marginBottom: "40px" }}>
          <div className="span-blue-40">
            <span id="font-SCD7">회원가입</span>
          </div>
          <hr></hr>
        </div>

        <div>
          <div className="span-left-text" id="font-SCD4">
            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">아이디(이메일)</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="email"
                value={email}
              ></input>
              {emptyinputs === "email" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">{idValidMsg}</span>
                </div>
              )}
            </div>

            <div className="">
              <div className="span-gray-text">
                <span className="">비밀번호</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="password"
                name="password"
                value={password}
              ></input>

              <div style={{ marginBottom: "20px", width: "98%" }}>
                <span className="span-gray-small-text">
                  ※ 문자 및 숫자를 조합한 6자리 이상으로 구성
                </span>
              </div>
              <div style={{ marginTop: "-20px", marginBottom: "15px" }}>
                {emptyinputs === "pw" && (
                  <span className="warning-text">비밀번호를 입력해주세요.</span>
                )}
                {!passwordValid && (
                  <span className="warning-text">
                    문자 및 숫자를 조합한 6자리 이상으로 구성해주세요.
                  </span>
                )}
              </div>
            </div>
            <br></br>
            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">비밀번호 확인</span>
              </div>
              <input
                onChange={inputPwchk}
                className="input-form-w97p-40"
                type="password"
                name="pwchk"
                value={pwchk}
              ></input>

              {!passwordChkValid ? (
                <div style={{ marginTop: "-5px", marginBottom: "20px" }}>
                  <span className="warning-text-pw">
                    비밀번호 확인을 해주세요.
                  </span>
                </div>
              ) : pwchk === "" ? (
                <></>
              ) : password === pwchk ? (
                <div style={{ marginTop: "-5px", marginBottom: "20px" }}>
                  <span className="passing-text-pw">
                    비밀번호가 일치합니다.
                  </span>
                </div>
              ) : (
                <div style={{ marginTop: "-5px", marginBottom: "20px" }}>
                  <span className="warning-text-pw">
                    비밀번호가 일치하지 않습니다.
                  </span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">이름</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40" /*의료기관 : medical institution*/
                type="text"
                name="name"
                value={name}
              ></input>
              {emptyinputs === "name" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">이름을 입력해주세요</span>
                </div>
              )}
            </div>

            <div className="input-form" style={{ marginTop: "10px" }}>
              <div className="span-gray-text" style={{ float: "left" }}>
                <span className="input-label">성별</span>
              </div>
              <div className="radio-box" style={{ marginLeft: "70px" }}>
                <div className="radio-box-l">
                  <input
                    onChange={inputChange}
                    type="radio"
                    name="gender"
                    value="M"
                    checked={gender === "M"}
                  ></input>
                  <label onClick={() => radioLabelBtnClick("M")}>남성</label>
                </div>
                <div className="radio-box-r">
                  <input
                    onChange={inputChange}
                    type="radio"
                    name="gender"
                    value="F"
                    checked={gender === "F"}
                  ></input>
                  <label onClick={() => radioLabelBtnClick("F")}>여성</label>
                </div>
              </div>
            </div>
            <div style={{ clear: "both", marginBottom: "20px" }}></div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">연락처(휴대폰번호)</span>
              </div>
              <input
                onChange={phoneValidate}
                className="input-form-w97p-40"
                type="text"
                name="phone"
                value={phone}
                maxLength={13}
              ></input>
              {emptyinputs === "phone" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">연락처를 입력해주세요.</span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">의료기관명</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="orgNm"
                value={orgNm}
              ></input>
              {emptyinputs === "orgNm" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">
                    의료기관명을 입력해주세요.
                  </span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">요양기관번호</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="orgNum"
                value={orgNum}
              ></input>
              {emptyinputs === "orgNum" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">
                    요양기관번호을 입력해주세요.
                  </span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">주소(의료기관 기준)</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="addr"
                value={addr}
                onClick={() => setAddModalOpen(true)}
              ></input>
              {emptyinputs === "addr" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">주소를 입력해주세요.</span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">상세주소</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="addDetail"
                value={addDetail}
              ></input>
            </div>
          </div>

          <div className="terms-form" id="font-SCD3">
            <div>
              <span
                className="term-title"
                onClick={() => {
                  btnShowTerms("A");
                }}
              >
                이용약관
              </span>
              <button
                onClick={() => {
                  btnShowTerms("A");
                }}
              >
                보기
              </button>
            </div>
            <div className="terms-radio-form">
              <span>해당 이용약관에 동의하십니까?</span>
              <label>예, 동의합니다.</label>
              <input
                type="checkbox"
                onChange={() => {
                  agreeTermsCheck("A");
                }}
                name="agreeTermsA"
                checked={agreeTermsA}
              ></input>
            </div>

            <div>
              <span
                className="term-title"
                onClick={() => {
                  btnShowTerms("C");
                }}
              >
                개인정보취급방침
              </span>
              <button
                onClick={() => {
                  btnShowTerms("C");
                }}
              >
                보기
              </button>
            </div>

            <div className="terms-radio-form">
              <span>해당 개인정보취급방침에 동의합니까? </span>
              <label>예, 동의합니다.</label>
              <input
                type="checkbox"
                onChange={() => {
                  agreeTermsCheck("C");
                }}
                name="agreeTermsC"
                checked={agreeTermsC}
              ></input>
            </div>

            <div>
              <span
                className="term-title"
                onClick={() => {
                  btnShowTerms("B");
                }}
              >
                [필수]회원 개인정보 수집 ・ 이용 동의서
              </span>
              <button
                onClick={() => {
                  btnShowTerms("B");
                }}
              >
                보기
              </button>
            </div>

            <div className="terms-radio-form">
              <span>개인정보 수집・이용하는 것에 동의합니다. </span>
              <label>예, 동의합니다.</label>
              <input
                type="checkbox"
                onChange={() => {
                  agreeTermsCheck("B");
                }}
                name="agreeTermsB"
                checked={agreeTermsB}
              ></input>
            </div>
          </div>
          <div className="img-form">
            <button
              className="btn-submit"
              onClick={onSubmit}
              disabled={submitBtn}
              id="font-SCD7"
            >
              완료
            </button>
          </div>
        </div>

        {/* <TermsModalShow></TermsModalShow>
      <AddClick></AddClick>
      <MsgModalShow></MsgModalShow> */}
        <div style={{ marginBottom: "50px" }}></div>
      </div>

      {addModalOpen && (
        <Post
          setAddModalOpen={setAddModalOpen}
          setRegInputs={setRegInputs}
          regInputs={regInputs}
        ></Post>
      )}
      {termsModalOpen && (
        <TermsModal
          setTermsModalOpen={setTermsModalOpen}
          terms={terms}
          termsModalCallback={termsModalCallback}
        ></TermsModal>
      )}
      {AlertModalOpen && (
        <AlertModal
          setOpenModal={setAlertModalOpen}
          modalMsg={AlertModalMsg}
          clickConfirm={alertConfirm}
        ></AlertModal>
      )}
      {modalOpen && (
        <MsgModal
          setOpenModal={setModalOpen}
          modalMsg={modalMsg}
          modalConfirm={modalConfirm}
        ></MsgModal>
      )}
      {isLoading && <Loader isLoading={isLoading}></Loader>}
    </div>
  );
};

export default Join;
